import type { ServiceFee } from "./zod/serviceFee";

export const platformServiceFee: ServiceFee | null = {
    ratePerOrder: 0,
    feePerOrder: 0,
};